import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, type WithSignal, type DashboardItemsRequest, type Spending } from '@shared/api';

const getSpendingEffect = createEffect(({ signal, ...request }: WithSignal<DashboardItemsRequest>) => DashboardApi.getSpending(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<Spending[]>([])
  .on(getSpendingEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getSpendingEffect.pending, (_, data) => data)
  .on(getSpendingEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getSpendingEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getSpendingEffect, () => null)
  // .on(getSpendingEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getSpendingEffect.fail, () => 'Something went wrong while fetching Spending by currency. Please try again.')
  .on(getSpendingEffect.done, () => null)
  .reset(clearEvent);

const getSpendingApi = ApiUtils.wrapperApi(getSpendingEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getSpendingApi.cancel());

export const $dashboardSpendingSummaryStore = {
  events: {
    getSpending: getSpendingApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
